export enum SelectionItemProductTour {
  TOUR_INVITE_TEAM_MEMBER = 'tour-invite-team_member',
  TOUR_REORDER = 'tour-reorder',
  TOUR_ADD_COMMENT = 'tour-add-comment',
}
